function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M13.934 32.782l28.503-2.494a1.5 1.5 0 0 1 .261 2.989l-31.49 2.755L8.46 4.63a1.5 1.5 0 1 1 2.989-.262l2.485 28.413zM10.347 8.983a1.5 1.5 0 0 1 .261 2.989l-5.977.522a1.5 1.5 0 1 1-.262-2.988l5.978-.523zm4.37 32.744a3 3 0 1 0-.523-5.978 3 3 0 0 0 .523 5.978zm.261 2.988a6 6 0 1 1-1.045-11.954 6 6 0 0 1 1.045 11.954zM29.472 20.88c0 1.036-.672 1.875-1.5 1.875-.829 0-1.5-.84-1.5-1.875v-3.75c0-1.036.671-1.875 1.5-1.875.828 0 1.5.84 1.5 1.875v3.75zm-1.5-10.125a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm0 15a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0 3c-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12s-5.373 12-12 12z"
});

var SvgTransmission = function SvgTransmission(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgTransmission;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/transmission.svg
// module id = 146
// module chunks = 0 1